/* eslint-disable react-hooks/exhaustive-deps */

// React Imports
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

// Redux Imports
import { beneCategories } from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification.js";
import {
  disableCategory,
  enableCategory,
} from "../../../../redux/features/customCategory/index.js";

// Component Imports
import BeneCategoryImageChecker from "../../../../components/Accounts/BeneCategoryImageChecker";
import Loader from "../../../../components/Loader/Index.jsx";
import PrimaryWithIconButton from "../../../../components/_utils/CommonButtons/PrimaryWithIconButton/index.jsx";
import CommonCalendar from "../../../../components/_utils/CommonCalendar/index.jsx";
import MultiSelectDropDownComponent from "../../../../components/_utils/CommonDropdown/MultiSelectDropdown/index.jsx";
import CommonTimePicker from "../../../../components/_utils/CommonDropdown/SetTime/index.jsx";
import SingleSelectDropDownComponent from "../../../../components/_utils/CommonDropdown/SingleSelectDropdown/index.jsx";
import CommonFileUpload from "../../../../components/_utils/CommonFileUpload";
import TextInputField from "../../../../components/_utils/CommonInputFields/TextInputField.jsx";
import CommonQuantity from "../../../../components/_utils/CommonQuantity";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup/index.jsx";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonToggleCard from "../../../../components/_utils/TransactionCommonComponents/CommonToggleCard.jsx";
import SmallPopupWithBulltePoint from "../../../../components/_utils/CommonSmallPopupWithBulletPoint/index.jsx";

// Utils Imports
import { custom_category_base_url } from "../../../../utils/categoryIconMapper.js";
import {
  GlobalConfiguration,
  maxFileSize,
} from "../../../../utils/configurationProvider.js";
import globalText from "../../../../utils/globalText";
import { globalTextFormat } from "../../../../utils/globalTextFormat.js";
import useCategories from "../../../../utils/useCategories.js";
import { toast } from "react-toastify";
import CommonToast from "../../../../components/_utils/CommonToast/index.jsx";
import useServiceChecker from "../../../../components/ServiceChecker/index.jsx";
import ICONS from "../../../../assets/Icons/index.js";

const CustomCategoryDashboard = () => {
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();

  const [endDate, setEndDate] = useState({});
  const [timeData, setTimeData] = useState({});
  const [startDate, setStartDate] = useState({});
  const [txnPayLoad, setTxnPayLoad] = useState({});
  const [quantities, setQuantities] = useState({});
  const [hyperLinks, setHyperLinks] = useState({});
  const [startDateCal, setStartDateCal] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [selectedCatData, setSelectedCatData] = useState();
  const [additionalData, setAdditionalData] = useState({});
  const [activatePopUp, setActivatePopUp] = useState(false);
  const [statusResponse, setStatusResponse] = useState(null);
  const [deactivatePopUp, setDeactivatePopUp] = useState(false);
  const [graphIsOpenInResp, setGraphIsOpenInResp] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedValueMonth, setSelectedValueMonth] = useState({});
  const [selectedCategoryName, setSelectedCategoryName] = useState(null);
  const [selectedValue, setSelectedValue] = useState({
    from: "Select",
    to: "Select",
  });

  const [ensureAll] = useServiceChecker();

  const hasCTransactionCategory = ensureAll(["CTransactionCategory"]).status;

  const hasAdmin = ensureAll(["Admin"]).status;

  const categories = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const isLoading = useSelector(
    (state) => state.beneAllVerification.isTransCateLoading,
  );

  const specificCategoryData = categories.find((data) => data?.id === +id);

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1975 + 1 },
    (_, i) => 1975 + i,
  );
  const days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handleInputChange = (eventOrData, fallbackDataType) => {
    const e = eventOrData?.target ? eventOrData : { target: eventOrData };
    const { name, value, data_typeChan } = e.target;

    const field = selectedCategory?.configuration?.data?.find(
      (field) => field.name === name,
    );
    const dataType = data_typeChan || fallbackDataType || field?.data_type;

    if (dataType === "numeric" && value?.toString().length > 15) return;

    const preserveTypes = [
      "date",
      "year",
      "toggle",
      "time",
      "quantity",
      "from_year_to_year",
      "month_year",
      "date_range",
      "multi_select_list",
      "upload",
    ];

    const trimmedValue =
      typeof value === "string" &&
      !preserveTypes.includes(dataType?.toLowerCase?.())
        ? value.replace(/^\s+/, "")
        : value;

    setAdditionalData((prev) => {
      const nextState = { ...prev, [name]: trimmedValue };
      return nextState;
    });

    setTxnPayLoad((prev) => {
      const updatedMerge = prev?.mergeCategory?.map((item) =>
        item?.name === name && item?.data_type === dataType
          ? { ...item, value: trimmedValue }
          : item,
      );
      return { ...prev, mergeCategory: updatedMerge };
    });
  };

  const handleToggle = (fieldName, data_type, initialValue) => {
    const currentValInState = additionalData[fieldName];
    const newValue =
      currentValInState !== undefined ? !currentValInState : !initialValue;

    handleInputChange({
      target: {
        name: fieldName,
        value: newValue,
        data_typeChan: data_type,
      },
    });
  };

  const handleFileChange = (file, key, field) => {
    if (file.size > maxFileSize) {
      CommonToast({
        text: "Maximum file size is 12mb.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      return;
    }

    setUploadedFiles((prev) => ({ ...prev, [key]: file }));

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
    }

    handleInputChange({
      target: {
        name: field?.name,
        value: file,
        data_typeChan: field?.data_type,
      },
    });
  };

  const handleTimeConfirm = (
    fieldname,
    data_type,
    hourShow,
    minuteShow,
    meridiemShow,
  ) => {
    const keyTime = `${fieldname}_${data_type}`;

    setTimeData((prev) => ({
      ...prev,
      [keyTime]: {
        hours: hourShow,
        minutes: minuteShow,
        meridiems: meridiemShow,
      },
    }));

    handleInputChange({
      target: {
        name: fieldname,
        value: `${hourShow}:${minuteShow} ${meridiemShow}`,
        data_typeChan: data_type,
      },
    });
  };

  const formatDate = (date) => {
    return `${date.getDate()} ${date.toLocaleString("default", {
      month: "short",
    })}, ${date.getFullYear()}`;
  };

  const handleClearTime = (key, field) => {
    const { [field]: _, ...updatedData } = additionalData;
    setAdditionalData(updatedData);
    setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState?.mergeCategory?.map((item) =>
        item?.data_type === "time" ? { ...item, value: "" } : item,
      ),
    }));
    setTimeData((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const handleDateformat = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";

    return new Date(d.getTime() - d.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 10);
  };

  const handleDateChange = (dates, key, name, type) => {
    const [start, end] = dates;

    setStartDate((prev) => ({
      ...prev,
      [key]: start || null,
    }));

    setEndDate((prev) => ({
      ...prev,
      [key]: end || null,
    }));

    if (start && end) {
      const startIso = handleDateformat(start);
      const endIso = handleDateformat(end);

      const formattedValue = `${startIso} to ${endIso}`;

      handleInputChange({
        target: {
          name,
          value: formattedValue,
          data_type: type,
        },
      });
    }
  };

  const handleConfirmCal = (fieldname, data_type, value, key) => {
    handleInputChange({
      target: {
        name: fieldname,
        value: formatDate(value),
        data_typeChan: data_type,
      },
    });
  };

  const handleChange = (value, field, key) => {
    setHyperLinks((prev) => ({
      ...prev,
      [key]: value,
    }));

    handleInputChange({
      target: {
        name: field?.name,
        value: value,
        data_typeChan: field?.data_type,
      },
    });
  };

  const clearField = (field, key) => {
    const { [field.name]: _, ...updatedData } = additionalData;
    setAdditionalData(updatedData);
    setTxnPayLoad((prevState) => ({
      ...prevState,
      mergeCategory: prevState?.mergeCategory?.map((item) =>
        item?.data_type === "hyperlink" ? { ...item, value: "" } : item,
      ),
    }));
    setHyperLinks((prev) => {
      const updated = { ...prev };
      delete updated[key];
      return updated;
    });
  };

  const renderFields = () => {
    const fields = selectedCatData?.[0]?.configuration?.data;
    if (!fields || fields.length === GlobalConfiguration?.lengthCheckZero) {
      return (
        <div className="text-text-secondary text-font-xs">
          There are no additional fields created for this category. Edit
          category to add additional fields.
        </div>
      );
    }

    return (
      <>
        {fields.map((field, index) => {
          const isFieldRequired = field?.mandatory === "Y";
          const optionalLabel = isFieldRequired ? "" : " (optional)";
          const fieldValue = additionalData[field.name] || "";
          switch (field.data_type) {
            case "string":
            case "numeric":
              return (
                <div>
                  <TextInputField
                    placeholder={`${field.name}${optionalLabel}`}
                    name={field.name}
                    value={fieldValue || ""}
                    fontKind="big"
                    bgColor="var(--primary-card)"
                    fgColor="var(--text-primary)"
                    variant={"default"}
                    adornment=""
                    isFullWidth={true}
                    onInput={(e) =>
                      handleInputChange(e, {
                        target: {
                          name: field.name,
                          value: fieldValue,
                          data_typeChan: field?.data_type,
                        },
                      })
                    }
                  />
                </div>
              );
            case "list":
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
                  <SingleSelectDropDownComponent
                    options={field?.data || []}
                    selected={fieldValue || ""}
                    setSelected={(val) =>
                      handleInputChange({
                        target: {
                          name: field.name,
                          value: val,
                          data_typeChan: field?.data_type,
                        },
                      })
                    }
                    type="big"
                    placeholder="Select"
                    showSearch={false}
                    disabled={field?.disabled}
                    isOpen={false}
                  />
                </div>
              );
            case "hyperlink":
              const keyHyper = `${field.name}_${field.data_type}`;
              const currentValue = hyperLinks?.[keyHyper] || "";
              return (
                <TextInputField
                  value={currentValue}
                  placeholder={`${field.name}`}
                  name={`hyperLink-${keyHyper}`}
                  bgColor="var(--primary-card)"
                  fgColor="var(--text-primary)"
                  isFullWidth={true}
                  onInput={(e) => handleChange(e.target.value, field, keyHyper)}
                  variant="default"
                  adornment={
                    "https://q2pay.in/new_assets/common/create_flow/close.svg"
                  }
                  onAdornmentClick={() => clearField(field, keyHyper)}
                />
              );
            case "time":
              const keyTime = `${field.name}_${field.data_type}`;
              const currentValueHours = timeData?.[keyTime]?.hours || "";
              const currentValueMinutes = timeData?.[keyTime]?.minutes || "";

              let isTimeSelectedShowButton =
                currentValueHours !== "" &&
                currentValueMinutes !== "" &&
                fieldValue !== undefined;

              return (
                <div className="w-width-full flex flex-col gap-gap-xs">
                  <h1 className="text-font-xs text-text-secondary">
                    {`${field.name}${
                      isFieldRequired ? "" : ""
                    }${optionalLabel}`}
                  </h1>
                  <CommonTimePicker
                    handleTimeConfirm={handleTimeConfirm}
                    handleClearTime={handleClearTime}
                    data_type={field?.data_type}
                    fieldname={field.name}
                    value={isTimeSelectedShowButton ? fieldValue : ""}
                    keyTime={keyTime}
                    timeData={timeData}
                    setTimeData={setTimeData}
                  />
                </div>
              );
            case "day":
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
                  <SingleSelectDropDownComponent
                    options={days}
                    selected={fieldValue || ""}
                    setSelected={(value) =>
                      handleInputChange({
                        target: {
                          name: field.name,
                          value: value,
                          data_typeChan: field?.data_type,
                        },
                      })
                    }
                    type="big"
                    placeholder="Select"
                    showSearch={false}
                    disabled={false}
                    isOpen={false}
                  />
                </div>
              );
            case "toggle":
              const currentToggleState =
                additionalData[field.name] !== undefined
                  ? additionalData[field.name]
                  : field.value;

              return (
                <div
                  className="flex flex-col gap-gap-xs"
                  key={index}
                >
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>
                  <CommonToggleCard
                    description={field?.description}
                    state={Boolean(currentToggleState)}
                    isDisabled={field?.disabled}
                    handleClick={() =>
                      handleToggle(field?.name, field?.data_type, field?.value)
                    }
                  />
                </div>
              );

            case "month":
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
                  <SingleSelectDropDownComponent
                    options={months}
                    selected={fieldValue || ""}
                    setSelected={(value) =>
                      handleInputChange({
                        target: {
                          name: field.name,
                          value: value,
                          data_typeChan: field?.data_type,
                        },
                      })
                    }
                    type="big"
                    placeholder="Select"
                    showSearch={false}
                    disabled={false}
                    isOpen={false}
                  />
                </div>
              );
            case "upload":
              const key = `${field.name}_${field.data_type}`;
              const file = uploadedFiles[key];
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name === "File" ? "Upload File" : field.name}${optionalLabel}`}
                  </p>
                  <CommonFileUpload
                    id={key}
                    files={file || []}
                    setFiles={(selectedFile) => {
                      handleFileChange(selectedFile, key, field);
                    }}
                    isDisabled={false}
                    type={
                      field?.data_type.toLowerCase() === "upload"
                        ? "all"
                        : "both"
                    }
                  />
                </div>
              );
            case "date":
              const keyDate = `${field.name}_${field.data_type}`;
              const currentValueDate = startDateCal?.[keyDate] || "";
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-font-xs text-text-secondary">{`${field.name}${optionalLabel}`}</p>
                  <CommonCalendar
                    startDate={currentValueDate}
                    selectionType="single"
                    type="big"
                    handleDateChange={(selectedDate) => {
                      handleConfirmCal(
                        field?.name,
                        field?.data_type,
                        selectedDate,
                        keyDate,
                      );
                    }}
                  />
                </div>
              );
            case "multi_select_list":
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
                  <MultiSelectDropDownComponent
                    options={field?.data || []}
                    selected={fieldValue || []}
                    setSelected={(newSelected) =>
                      handleInputChange({
                        target: {
                          name: field.name,
                          value: newSelected,
                          data_typeChan: field?.data_type,
                        },
                      })
                    }
                    isOpen={false}
                    showSearch={false}
                    placeholder="Select"
                    disabled={false}
                    type="big"
                  />
                </div>
              );
            case "year":
              return (
                <div className="flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">{`${field.name}${optionalLabel}`}</p>
                  <SingleSelectDropDownComponent
                    options={years}
                    selected={fieldValue || ""}
                    setSelected={(val) => {
                      handleInputChange({
                        target: {
                          name: field.name,
                          value: val,
                          data_typeChan: field?.data_type,
                        },
                      });
                    }}
                    isOpen={false}
                    showSearch={false}
                    placeholder="Select"
                    disabled={false}
                    type="big"
                  />
                </div>
              );
            case "quantity":
              const keyQuantity = `${field.name}_${field.data_type}`;
              const currentValueQuantity = quantities?.[keyQuantity] || 0;

              return (
                <div className="w-width-full flex flex-col gap-gap-xs">
                  <label
                    htmlFor={keyQuantity}
                    className="text-text-secondary text-font-xs"
                  >
                    {`${field.name}${optionalLabel}`}
                  </label>

                  <CommonQuantity
                    quantity={currentValueQuantity}
                    setQuantity={(val) => {
                      setQuantities?.((prev) => ({
                        ...prev,
                        [keyQuantity]: val,
                      }));

                      handleInputChange({
                        target: {
                          name: field.name,
                          value: val,
                          data_typeChan: field?.data_type,
                        },
                      });
                    }}
                    isDisabled={false}
                  />
                </div>
              );
            case "from_year_to_year":
              const keyYear = `${field.name}_${field.data_type}`;
              const currentYear = selectedValue[keyYear];
              return (
                <div className="w-width-full">
                  <div className="flex flex-row gap-gap-md w-width-full">
                    <div className="w-width-md flex flex-col gap-gap-xs">
                      <p className="text-text-secondary text-font-xs">
                        {`${field.name}${optionalLabel}`}
                      </p>
                      <SingleSelectDropDownComponent
                        options={years}
                        selected={currentYear?.from || ""}
                        setSelected={(value) => {
                          const updatedYear = { ...currentYear, from: value };

                          setSelectedValue?.((prev) => ({
                            ...prev,
                            [keyYear]: updatedYear,
                          }));

                          handleInputChange({
                            target: {
                              name: field.name,
                              value: updatedYear,
                              data_typeChan: field?.data_type,
                            },
                          });

                          setAdditionalData?.((prev) => ({
                            ...prev,
                            [field?.name]: updatedYear,
                          }));

                          setTxnPayLoad?.((prev) => ({
                            ...prev,
                            [field?.name]: updatedYear,
                          }));
                        }}
                        type="big"
                        placeholder="Select"
                        showSearch={false}
                        disabled={false}
                        isOpen={false}
                      />
                    </div>

                    <div className="w-width-md flex flex-col gap-gap-xs">
                      <p className="text-text-secondary text-font-xs">
                        {`${field.name}${optionalLabel}`}
                      </p>
                      <SingleSelectDropDownComponent
                        options={years}
                        selected={currentYear?.to || ""}
                        setSelected={(value) => {
                          const updatedYear = { ...currentYear, to: value };
                          setSelectedValue?.((prev) => ({
                            ...prev,
                            [keyYear]: updatedYear,
                          }));

                          handleInputChange({
                            target: {
                              name: field.name,
                              value: updatedYear,
                              data_typeChan: field?.data_type,
                            },
                          });

                          setAdditionalData?.((prev) => ({
                            ...prev,
                            [field?.name]: updatedYear,
                          }));

                          setTxnPayLoad?.((prev) => ({
                            ...prev,
                            [field?.name]: updatedYear,
                          }));
                        }}
                        type="big"
                        placeholder="Select"
                        showSearch={false}
                        disabled={false}
                        isOpen={false}
                      />
                    </div>
                  </div>
                </div>
              );
            case "month_year":
              const keyMonthYear = `${field.name}_${field.data_type}`;
              const currentMonthYear = selectedValueMonth[keyMonthYear];
              return (
                <div className="flex gap-gap-md w-width-full">
                  <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                    <p className="text-text-secondary text-font-xs">
                      {`${field.name}${optionalLabel}`}
                    </p>
                    <SingleSelectDropDownComponent
                      options={months}
                      selected={currentMonthYear?.month || ""}
                      setSelected={(val) => {
                        setSelectedValueMonth((prev) => ({
                          ...prev,
                          [keyMonthYear]: { ...prev[keyMonthYear], month: val },
                        }));
                        handleInputChange({
                          target: {
                            name: field.name,
                            value: { ...currentMonthYear, month: val },
                            data_typeChan: field?.data_type,
                          },
                        });
                      }}
                      isOpen={false}
                      showSearch={false}
                      placeholder="Select"
                      disabled={false}
                      type="big"
                    />
                  </div>

                  <div className="flex-1 min-w-min-width-base flex flex-col gap-gap-xs">
                    <p className="text-text-secondary text-font-xs">
                      {`${field.name}${optionalLabel}`}
                    </p>
                    <SingleSelectDropDownComponent
                      options={years}
                      selected={currentMonthYear?.year || ""}
                      setSelected={(val) => {
                        setSelectedValueMonth((prev) => ({
                          ...prev,
                          [keyMonthYear]: { ...prev[keyMonthYear], year: val },
                        }));
                        handleInputChange({
                          target: {
                            name: field.name,
                            value: { ...currentMonthYear, year: val },
                            data_typeChan: field?.data_type,
                          },
                        });
                      }}
                      isOpen={false}
                      showSearch={false}
                      placeholder="Select"
                      disabled={false}
                      type="big"
                    />
                  </div>
                </div>
              );
            case "date_range":
              const keyMultiDate = `${field.name}_${field.data_type}`;
              const currentValueFromDate = startDate?.[keyMultiDate] ?? null;
              const currentValueToDate = endDate?.[keyMultiDate] ?? null;

              return (
                <div className="w-width-full flex flex-col gap-gap-xs">
                  <p className="text-text-secondary text-font-xs">
                    {`${field.name}${optionalLabel}`}
                  </p>
                  <CommonCalendar
                    selectionType="range"
                    type="big"
                    startDate={currentValueFromDate}
                    endDate={currentValueToDate}
                    handleDateChange={(dates) => {
                      handleDateChange(
                        dates,
                        keyMultiDate,
                        field?.name,
                        field?.data_type,
                      );
                    }}
                  />
                </div>
              );
            default:
              return null;
          }
        })}
      </>
    );
  };

  const handleActivate = async () => {
    let response;
    try {
      CommonToast({
        text: "Activating category.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--processing)",
      });
      toast.dismiss();
      response = await dispatch(enableCategory(id));
      setStatusResponse(response);
      setActivatePopUp(false);
      if (response?.payload?.status === true) {
        CommonToast({
          text: "Category activated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setActivatePopUp(false);
      } else {
        if (response?.payload?.errors?.name) {
          CommonToast({
            text: response?.payload?.errors?.name?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else if (response?.payload?.errors?.base) {
          CommonToast({
            text: response?.payload?.errors?.base?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else if (response?.payload?.errors?.configuration) {
          CommonToast({
            text: response?.payload?.errors?.configuration?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setActivatePopUp(false);
      }
    } catch (err) {
      setActivatePopUp(false);
    } finally {
    }
  };

  const handleDeactivate = async () => {
    let response;
    try {
      CommonToast({
        text: "Deactivating category.",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--processing)",
      });
      toast.dismiss();
      response = await dispatch(disableCategory(id));
      setStatusResponse(response);
      setDeactivatePopUp(false);
      if (response?.payload?.status === true) {
        CommonToast({
          text: "Category deactivated successfully.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setDeactivatePopUp(false);
      } else {
        if (response?.payload?.errors?.name) {
          CommonToast({
            text: response?.payload?.errors?.name?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else if (response?.payload?.errors?.base) {
          CommonToast({
            text: response?.payload?.errors?.base?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        } else if (response?.payload?.errors?.configuration) {
          CommonToast({
            text: response?.payload?.errors?.configuration?.[0],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setDeactivatePopUp(false);
      }
    } catch (err) {
      setDeactivatePopUp(false);
    } finally {
    }
  };

  useEffect(() => {
    if (statusResponse) dispatch(beneCategories());
  }, [statusResponse]);

  useEffect(() => {
    if (!additionalData) return;

    const storeData = txnPayLoad?.selectedCategory?.configuration?.data?.map(
      (val) => {
        const dataValue = additionalData[val?.name];

        if (dataValue !== undefined && dataValue !== "") {
          if (val?.data_type === "numeric") {
            const integerValue = parseInt(dataValue, 10);
            if (!isNaN(integerValue)) {
              return { ...val, value: integerValue };
            } else {
              return val;
            }
          } else {
            return { ...val, value: dataValue };
          }
        } else if (val?.data_type === "multi_select_list") {
          return { ...val, value: [] };
        } else if (val?.data_type === "toggle") {
          return { ...val, value: false };
        } else if (val?.data_type === "hyperlink") {
          return { ...val, value: "" };
        } else if (val?.data_type === "time") {
        } else if (val?.mandatory !== "Y") {
          return { ...val, value: "Not Given" };
        }

        return val;
      },
    );

    setTxnPayLoad({
      ...txnPayLoad,
      mergeCategory: storeData,
    });
  }, [additionalData, txnPayLoad?.selectedCategory]);
  useEffect(() => {
    if (categories?.length > GlobalConfiguration?.lengthCheckZero) {
      const filteredCatData = categories.filter((cat) => cat?.id === +id);
      setSelectedCatData(filteredCatData);

      if (!selectedCategory && categories?.[0]?.name) {
        setSelectedCategory(categories?.[0]?.id);
        setSelectedCategoryName(categories?.[0]?.name);
      }

      setAdditionalData({});
      setTxnPayLoad((prev) => ({ ...prev, mergeCategory: [] }));
      setHyperLinks({});
      setTimeData({});
      setUploadedFiles({});
      setStartDate({});
      setEndDate({});
      setStartDateCal({});
      setSelectedValueMonth({});
      setSelectedValue({ from: "Select", to: "Select" });
      setQuantities({});
    }
  }, [categories, selectedCategory]);

  return (
    <>
      {deactivatePopUp && (
        <div className="fixed top-top-base left-left-base w-full-width h-full-height z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          {/* <div> */}
          <SmallPopupWithBulltePoint
            headerTitle={"Are you sure you want to deactivate this category?"}
            headerFontWeight="semibold"
            headerFontColor="var(--text-primary)"
            textSize="font-md"
            secondHeaderTitle={
              "Deactivating this category will result in the following changes:"
            }
            bulletPoints={[
              "Pending transactions associated with this category will fail upon approval and can be sent for recreation.",
              "New accounts and transactions will not have this category available for selection.",
            ]}
            btnOneText="Cancel"
            btnOneBtnType="button"
            btnOneEnabledBgColor="transparent"
            btnOneHandleFunction={() => setDeactivatePopUp(false)}
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText="Deactivate"
            btnTwoBtnType="button"
            btnTwoHandleFunction={() => handleDeactivate()}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoHoverOption="black"
          />
          {/* </div> */}
        </div>
      )}
      {activatePopUp && (
        <div
          onClick={() => {
            setActivatePopUp(false);
          }}
          className="fixed top-top-base left-left-base w-width-full h-height-full z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center"
        >
          <div>
            <SmallPopup
              headerTitle={globalText.ACTIVATE_CATEGORY_POPUP_MAIN_MESSAGE}
              headerFontWeight="semibold"
              headerFontColor="var(--custom-orange)"
              textSize="font-lg"
              subtext={
                "Activating this category will make it available for creating transactions and accounts."
              }
              btnOneText="Cancel"
              btnOneBtnType="button"
              btnOneEnabledBgColor="transparent"
              btnOneHandleFunction={() => setActivatePopUp(false)}
              btnOneOutLineColor="var(--text-primary)"
              btnOneEnabledTextColor="var(--text-primary)"
              btnOneIsDisabled={false}
              btnOneHoverOption="white"
              btnTwoText="Activate"
              btnTwoBtnType="button"
              btnTwoHandleFunction={handleActivate}
              btnTwoEnabledBgColor="var(--positive-act)"
              btnTwoEnabledTextColor="var(--text-primary)"
              btnTwoIsDisabled={false}
              btnTwoHoverOption="black"
            />
          </div>
        </div>
      )}

      {isLoading ? (
        <div className="fixed w-screen h-screen flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <>
          {graphIsOpenInResp &&
          (hasAdmin || selectedCatData?.[0]?.custom_category === "Y") ? (
            <div className="fixed w-width-full bottom-bottom-base z-z-index-fixed-ui Qsmd:hidden flex">
              <div
                className={`${selectedCatData?.[0]?.active === "Y" ? "bg-negative-act " : "bg-positive-act"} w-width-full py-padding-md flex gap-gap-sm justify-center items-center ${
                  !hasCTransactionCategory
                    ? "opacity-light-opacity cursor-not-allowed"
                    : selectedCatData?.[0]?.active === "Y"
                      ? "opacity-base-opacity relative z-z-index-content cursor-pointer global-hover-white"
                      : "opacity-base-opacity relative z-z-index-content cursor-pointer global-hover-black"
                }`}
                onClick={() => {
                  if (hasCTransactionCategory) {
                    if (selectedCatData?.[0]?.active === "Y") {
                      setDeactivatePopUp(true);
                    } else {
                      setActivatePopUp(true);
                    }
                  } else {
                    navigate("/feature_not_assigned", {
                      state: {
                        unavailableService: "CTransactionCategory",
                      },
                    });
                  }
                }}
              >
                <div>
                  <img
                    className="w-icon-md h-icon-md"
                    src={
                      selectedCatData?.[0]?.active === "Y"
                        ? "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                        : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                    }
                    alt={
                      selectedCatData?.[0]?.active === "Y"
                        ? "Reject Icon"
                        : "Activate Icon"
                    }
                  />
                </div>
                <div className="text-text-primary font-semibold text-font-md text-center">
                  {selectedCatData?.[0]?.active === "Y"
                    ? "Deactivate category"
                    : "Activate category"}
                </div>
              </div>
            </div>
          ) : null}

          <div className="h-full-height relative text-text-primary flex flex-col overflow-hidden">
            <div className="w-width-full flex flex-col sticky top-top-base z-z-index-tooltip bg-primary-nav">
              <div className="h-navbar-breadcrumb-height Qsmd:block hidden"></div>
              <div className="w-width-full h-auto">
                <div className="max-w-tab-width-normal mx-auto w-width-full flex Qsmd:flex-row flex-col">
                  <div className="flex Qsmd:hidden gap-gap-md py-padding-sm shadow-box-shadow-bottom">
                    <div
                      className="w-icon-sm h-icon_w-icon-sm items-center ml-margin-sm flex cursor-pointer"
                      onClick={() => {
                        navigate(GlobalConfiguration?.navigate_back);
                      }}
                    >
                      <SVGComponent
                        url="https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                        height="var(--icon-sm)"
                        width="var(--icon-sm)"
                        color="var(--text-primary)"
                        alt="Arrow Left White"
                      />
                    </div>

                    <div className="flex flex-col gap-gap-xs">
                      <p className="text-font-md text-text-primary font-normal">
                        {globalText.CATEGORIES}
                      </p>
                      <p className="text-font-xs text-text-secondary font-normal">
                        {globalText.VIEW_DETAILS}
                      </p>
                    </div>
                  </div>

                  <div className="Qsmd:flex w-width-full items-center justify-between py-padding-sm px-padding-md Qlg:px-padding-base gap-x-gap-sm">
                    {
                      <p className="text-text-primary text-font-xs flex-1">
                        {specificCategoryData?.custom_category === "Y"
                          ? specificCategoryData?.active === "Y"
                            ? `${globalText?.DEACTIVATE_THIS_CATEGORY_MESSAGE}`
                            : `${globalText?.ACTIVATE_THIS_CATEGORY_MESSAGE}`
                          : hasAdmin
                            ? specificCategoryData?.active === "Y"
                              ? `${globalText?.DEACTIVATE_THIS_CATEGORY_MESSAGE}`
                              : `${globalText?.ACTIVATE_THIS_CATEGORY_MESSAGE}`
                            : "Default category is not editable. Please contact admin, in order to edit."}
                      </p>
                    }
                    {(hasAdmin ||
                      specificCategoryData?.custom_category === "Y") && (
                      <div className="hidden Qmd:flex flex-row gap-x-gap-sm bottom-bottom-base flex-1 justify-end">
                        <PrimaryWithIconButton
                          btnText="Edit category"
                          btnType="button"
                          isDisabled={specificCategoryData?.active === "Y"}
                          handleFunction={() => {
                            if (specificCategoryData?.active === "N") {
                              if (hasCTransactionCategory) {
                                navigate(
                                  "/settings/category_dashboard/edit_category",
                                  {
                                    state: {
                                      id: specificCategoryData?.id,
                                      name: specificCategoryData?.name,
                                      description:
                                        specificCategoryData?.description,
                                      configuration:
                                        specificCategoryData?.configuration,
                                      asset_properties: {
                                        resource_name:
                                          specificCategoryData?.asset_properties
                                            ?.resource_name,

                                        colour:
                                          specificCategoryData?.asset_properties
                                            ?.colour,
                                      },
                                    },
                                  },
                                );
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "CTransactionCategory",
                                  },
                                });
                              }
                            }
                          }}
                          enabledTextColor={"var(--text-primary)"}
                          disabledTextColor={"var(--text-primary)"}
                          enabledBgColor={"var(--primary-act)"}
                          disabledBgColor={"var(--primary-act)"}
                          icon="https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                          iconToBeAlign="right"
                        />
                        <PrimaryWithIconButton
                          btnText={
                            specificCategoryData?.active === "Y"
                              ? "Deactivate category"
                              : "Activate category"
                          }
                          btnType="button"
                          handleFunction={() => {
                            if (selectedCatData?.[0]?.active === "Y") {
                              if (hasCTransactionCategory) {
                                setDeactivatePopUp(true);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "CTransactionCategory",
                                  },
                                });
                              }
                            } else {
                              if (hasCTransactionCategory) {
                                setActivatePopUp(true);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "CTransactionCategory",
                                  },
                                });
                              }
                            }
                          }}
                          disabledTextColor={"var(--text-primary)"}
                          enabledBgColor={
                            selectedCatData?.[0]?.active === "Y"
                              ? "var(--negative-act)"
                              : "var(--positive-act)"
                          }
                          enabledTextColor={"var(--text-primary"}
                          disabledBgColor={"var(--primary-act)"}
                          icon={
                            specificCategoryData?.active === "Y"
                              ? "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                              : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                          }
                          iconToBeAlign="right"
                          isDisabled={!hasCTransactionCategory}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {graphIsOpenInResp ? (
                <div>
                  <div className="Qsmd:max-w-custom-category-header-left-section-width Qsmd:w-width-full w-full-width px-padding-md py-padding-sm bg-primary-nav-act Qsmd:hidden flex items-center gap-gap-sm justify-between z-z-index-tooltip relative">
                    <div className="flex relative w-width-lg">
                      <div
                        className="flex items-center mr-margin-md cursor-pointer"
                        onClick={() => {
                          setGraphIsOpenInResp("");
                        }}
                      >
                        <SVGComponent
                          url={
                            "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                          }
                          height={"var(--icon-sm)"}
                          width={"var(--icon-sm)"}
                          color={"var(--text-primary)"}
                        />
                      </div>
                      <div className="rounded-border-radius-sm h-auto w-width-full gap-gap-sm flex items-center">
                        <div className="bg-text-primary p-padding-button-m rounded-border-radius-md">
                          <div className="h-icon-md w-icon-md">
                            {selectedCatData?.[0]?.asset_properties
                              ?.resource_name ? (
                              <SVGComponent
                                url={`${custom_category_base_url}/${selectedCatData?.[0]?.asset_properties?.resource_name}`}
                                height={"var(--icon-md)"}
                                width={"var(--icon-md)"}
                                color={
                                  selectedCatData?.[0]?.asset_properties?.colour
                                    ? `var(--${selectedCatData?.[0]?.asset_properties?.colour?.replaceAll("_", "-")})`
                                    : "var(--Custom-Category-Blue)"
                                }
                                alt={
                                  selectedCatData?.[0]?.asset_properties
                                    ?.resource_name
                                }
                              />
                            ) : (
                              <BeneCategoryImageChecker
                                category_url={categoryMapper(
                                  selectedCatData?.[0]?.name,
                                )}
                              />
                            )}
                          </div>
                        </div>
                        <div className="flex gap-gap-xs w-width-full items-center">
                          <div className="flex flex-col gap-gap-xs w-width-full">
                            <div className="flex gap-gap-xs w-width-full flex-1 items-center">
                              <div className="flex text-text-primary text-font-md font-semibold truncate w-width-full items-center relative">
                                <div className="flex gap-gap-xs items-center w-width-full">
                                  <span>{selectedCategoryName}</span>
                                  {"  "}
                                  {hasAdmin ||
                                  selectedCatData?.[0]?.custom_category ===
                                    "Y" ? null : (
                                    <p className="text-text-secondary text-font-xxs">
                                      ({globalText.DEFAULT_SMALL})
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>

                            <div className="text-text-secondary text-font-xs">
                              {globalTextFormat(globalText?.CATEGORY_NAME, [0])}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`flex items-center ${selectedCatData?.[0]?.active === "N" && selectedCatData?.[0]?.custom_category === "Y" ? "cursor-pointer" : "opacity-light-opacity cursor-not-allowed"}`}
                      onClick={() => {
                        if (hasCTransactionCategory || hasAdmin) {
                          if (selectedCatData?.[0]?.active === "N") {
                            navigate(
                              "/settings/category_dashboard/edit_category",
                              {
                                state: {
                                  id: selectedCatData?.[0]?.id,
                                  name: selectedCatData?.[0]?.name,
                                  description:
                                    selectedCatData?.[0]?.description,
                                  configuration:
                                    selectedCatData?.[0]?.configuration,
                                  logo_data: {},
                                },
                              },
                            );
                          }
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "CTransactionCategory",
                            },
                          });
                        }
                      }}
                    >
                      <SVGComponent
                        url={
                          "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                        }
                        height={"var(--icon-sm)"}
                        width={"var(--icon-sm)"}
                      />
                    </div>
                  </div>
                  <div className="Qsmd:max-w-custom-category-header-left-section-width Qsmd:w-width-full w-full-width py-padding-sm px-padding-md bg-primary-nav-act Qsmd:hidden flex items-center gap-gap-sm justify-between z-z-index-tooltip relative border-t-border border-t-primary-bg">
                    <div className="flex flex-col gap-gap-xs flex-1">
                      <div
                        className={`${
                          selectedCatData?.[0]?.active === "Y"
                            ? "text-settled"
                            : "text-failed"
                        } text-font-md capitalize font-semibold`}
                      >
                        {selectedCatData?.[0]?.active === "Y"
                          ? globalText.ACTIVE
                          : globalText.INACTIVE}
                      </div>
                      <div className="text-text-secondary text-font-xs">
                        {globalText.CATEGORY_STATUS}
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}
            </div>
            <div
              className={`overflow-y-auto h-full flex flex-col flex-1 items-center relative w-width-full Qmd:pb-padding-md ${!hasAdmin && specificCategoryData?.custom_category === "N" ? "pb-padding-md" : "pb-[calc(var(--stepper-moble-height)+var(--padding-md))]"}`}
            >
              <div className="max-w-tab-width-normal w-width-full flex flex-col Qsmd:flex-row gap-x-gap-xl gap-y-gap-md pt-padding-md Qmd:px-padding-md Qlg:px-padding-base">
                <div className="px-padding-md Qmd:px-padding-base w-width-full">
                  <div className="flex flex-col bg-primary-card w-width-full p-padding-md gap-y-gap-md rounded-border-radius-md">
                    <p className="text-text-primary text-font-md font-semibold">
                      Details
                    </p>
                    <TitleSubtitlePair
                      title={specificCategoryData?.name}
                      titleColor={"text-primary"}
                      subtitle={"Category name"}
                      variant="md"
                      isBold={false}
                    />
                    <div className="flex flex-row items-center justify-between">
                      <TitleSubtitlePair
                        title={
                          specificCategoryData?.active === "Y"
                            ? "Active"
                            : "Inactive"
                        }
                        titleColor={
                          specificCategoryData?.active === "Y"
                            ? "settled"
                            : "failed"
                        }
                        subtitle={"Category status"}
                        variant="md"
                        isBold={true}
                      />
                      <div className="flex items-center bg-text-primary p-padding-sm rounded-border-radius-sm">
                        {specificCategoryData?.asset_properties
                          ?.resource_name ? (
                          <SVGComponent
                            url={`${custom_category_base_url}/${specificCategoryData?.asset_properties?.resource_name}`}
                            height={"var(--icon-md)"}
                            width={"var(--icon-md)"}
                            color={
                              specificCategoryData?.asset_properties?.colour
                                ? `var(--${specificCategoryData?.asset_properties?.colour?.replaceAll("_", "-")})`
                                : "var(--Custom-Category-Blue)"
                            }
                            alt={
                              specificCategoryData?.asset_properties
                                ?.resource_name
                            }
                          />
                        ) : (
                          <img
                            className="w-icon-md h-icon-md"
                            src={categoryMapper(specificCategoryData?.name)}
                            alt="category"
                          />
                        )}
                      </div>
                    </div>
                    <TitleSubtitlePair
                      title={
                        specificCategoryData?.custom_category === "Y"
                          ? "Custom"
                          : "Default"
                      }
                      titleColor={"text-primary"}
                      subtitle={"Category type"}
                      variant="md"
                      isBold={false}
                    />
                    <TitleSubtitlePair
                      title={specificCategoryData?.description ?? "Not given"}
                      titleColor={"text-primary"}
                      subtitle={"Description"}
                      variant="md"
                      isBold={false}
                    />
                  </div>
                </div>
                <div className={`relative w-width-full bg-primary-bg flex `}>
                  <div className="w-width-full flex flex-col">
                    <div
                      className={`px-padding-md Qmd:px-padding-base w-auto h-height-full ${hasAdmin || selectedCatData?.[0]?.custom_category === "Y" ? "" : ""}`}
                    >
                      <div className="bg-primary-card rounded-border-radius-md w-width-full p-padding-md Qsmd:pb-padding-md pb-padding-xl">
                        <div className="flex flex-col gap-gap-xs">
                          <div className="text-text-primary font-semibold text-font-md">
                            {Object.keys(
                              specificCategoryData?.configuration || {},
                            ).length === GlobalConfiguration?.lengthCheckZero
                              ? "No Additional Fields Created"
                              : globalText.ADDITIONAL_DETAILS_PREVIEW}
                          </div>
                        </div>

                        <div className="w-width-full flex flex-col gap-gap-md mt-margin-md">
                          {renderFields()}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {(hasAdmin || specificCategoryData?.custom_category === "Y") && (
              <div className="flex Qmd:hidden fixed flex-row gap-x-gap-sm bottom-bottom-base p-padding-md bg-primary-nav rounded-t-border-radius-md w-width-full z-z-index-overlay">
                <PrimaryWithIconButton
                  btnText="Edit category"
                  btnType="button"
                  isDisabled={specificCategoryData?.active === "Y"}
                  handleFunction={() => {
                    if (specificCategoryData?.active === "N") {
                      if (hasCTransactionCategory) {
                        navigate("/settings/category_dashboard/edit_category", {
                          state: {
                            id: specificCategoryData?.id,
                            name: specificCategoryData?.name,
                            description: specificCategoryData?.description,
                            configuration: specificCategoryData?.configuration,
                            asset_properties: {
                              resource_name:
                                specificCategoryData?.asset_properties
                                  ?.resource_name,

                              colour:
                                specificCategoryData?.asset_properties?.colour,
                            },
                          },
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "CTransactionCategory",
                          },
                        });
                      }
                    }
                  }}
                  enabledTextColor={"var(--text-primary)"}
                  disabledTextColor={"var(--text-primary)"}
                  enabledBgColor={"var(--primary-act)"}
                  disabledBgColor={"var(--primary-act)"}
                  icon="https://q2pay.in/new_assets/common/detail_page/edit_with_white_circle.svg"
                  iconToBeAlign="right"
                  fullWidthRequired
                />
                <PrimaryWithIconButton
                  btnText={
                    specificCategoryData?.active === "Y"
                      ? "Deactivate category"
                      : "Activate category"
                  }
                  btnType="button"
                  handleFunction={() => {
                    if (selectedCatData?.[0]?.active === "Y") {
                      if (hasCTransactionCategory) {
                        setDeactivatePopUp(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "CTransactionCategory",
                          },
                        });
                      }
                    } else {
                      if (hasCTransactionCategory) {
                        setActivatePopUp(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "CTransactionCategory",
                          },
                        });
                      }
                    }
                  }}
                  disabledTextColor={"var(--text-primary)"}
                  enabledBgColor={
                    selectedCatData?.[0]?.active === "Y"
                      ? "var(--negative-act)"
                      : "var(--positive-act)"
                  }
                  enabledTextColor={"var(--text-primary"}
                  disabledBgColor={"var(--primary-act)"}
                  icon={
                    specificCategoryData?.active === "Y"
                      ? "https://q2pay.in/new_assets/common/approval/reject_icon_red_with_white_circle.svg"
                      : "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg"
                  }
                  iconToBeAlign="right"
                  fullWidthRequired
                  isDisabled={!hasCTransactionCategory}
                />
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default CustomCategoryDashboard;
